import axios from 'axios';
import {actions as A} from '../../constants/actions';
import {api} from '../../constants/api';
import {errors as E} from 'common/constants/errors';

export const submitStep = ({step, data}) => {
  return (dispatch) => {
    dispatch({
      type: A.GET_STEP_DATA
    });

    return axios.post(
      api.SUBMIT_STEP_BY_STEP_ID(step),
      {...data, shumaID: parseInt(data.shumaID, 10)}
    )
      .then((response) => {
        const {errorCode, body} = response.data;
        if (errorCode < 0) throw new Error(E.SERVER_ERROR);

        dispatch({
          type: A.GET_STEP_DATA_SUCCESS,
          payload: body
        });
      })
  };
};
